import React from 'react'
import Loadable from 'react-loadable'
import Loading from '../../components/loader/Loader'
import RolesEnum from '../../Enum/RolesEnum';
import TermosCondicoes from "../../../pages/termosCondicoes/TermosCondicoes";

const DashBoardMapComponent = Loadable({
  loader: () => import('../../../pages/dashboard/Dashboard'),
  loading: () => <Loading />
})

const DashBoardOperationComponent = Loadable({
  loader: () => import('../../../pages/dashboard/DashboardOperacao'),
  loading: () => <Loading />
})

const ChatComponent = Loadable({
  loader: () => import('../../../pages/chat/Chat'),
  loading: () => <Loading />
})

const LoginComponent = Loadable({
  loader: () => import('../../../pages/login/Login'),
  loading: () => <Loading />
})

const UsuariosComponent = Loadable({
  loader: () => import('../../../pages/usuario/Usuarios'),
  loading: () => <Loading />
})

const OrganizacoesComponent = Loadable({
  loader: () => import('../../../pages/organizacoes/Organizacoes'),
  loading: () => <Loading />
})

const QuadroDeAvisosComponent = Loadable({
  loader: () => import('../../../pages/quadroDeAvisos/QuadroDeAvisos'),
  loading: () => <Loading />
})

const CuponsComponent = Loadable({
  loader: () => import('../../../pages/cupons/Cupons'),
  loading: () => <Loading />
})

const DesempenhoComponent = Loadable({
  loader: () => import('../../../pages/desempenho/Desempenho'),
  loading: () => <Loading />
})

const TelefonnesBloqueadosComponent = Loadable({
  loader: () => import('../../../pages/telefonesBloqueados/TelefonesBloqueados'),
  loading: () => <Loading />
})

const IndiqueGanheComponent = Loadable({
  loader: () => import('../../../pages/indiqueGanhe/IndiqueGanhe'),
  loading: () => <Loading />
})


export default [
  {
    path: '/',
    title: 'Dashboard - Operação',
    component: DashBoardOperationComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  },
  {
    path: '/dashboard',
    title: 'Dashboard - Mapa',
    component: DashBoardMapComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  },
  {
    path: '/dashboard/operacao',
    title: 'Dashboard - Operação',
    component: DashBoardOperationComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  },
  {
    path: '/chat',
    title: 'Chat',
    component: ChatComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  },
  {
    path: '/login',
    title: 'Login',
    component: LoginComponent,
    isAuthenticated: false
  },
  {
    path: '/usuarios',
    title: 'Usuarios',
    component: UsuariosComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  },
  {
    path: '/organizacoes',
    title: 'Organizacoes',
    component: OrganizacoesComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  },
  {
    path: '/quadroDeAvisos',
    title: 'Quadro de Avisos',
    component: QuadroDeAvisosComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  },
  {
    path: '/cupons',
    title: 'Cupons',
    component: CuponsComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  },
  {
    path: '/desempenho',
    title: 'Desempenho',
    component: DesempenhoComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  },
  {
    path: '/telefonesBloqueados',
    title: 'Telefones Bloqueados',
    component: TelefonnesBloqueadosComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  },
  {
    path: '/termos-condicoes',
    title: 'Termos e condições',
    component: TermosCondicoes,
    isAuthenticated: true,
    roles: [RolesEnum.Organizacao],
    isFullScreen: true,
  },
  {
    path: '/indiqueGanhe',
    title: 'Indique e Ganhe',
    component: IndiqueGanheComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  }
]
